import { bake_cookie, read_cookie } from './cookies-service';

export class DemoService {
    private static instance: DemoService;
    private static readonly DEMO_COOKIE_NAME = 'zooza-demo-mode';
    private static readonly DEMO_COMPANY_ID = '0';

    public static getInstance(): DemoService {
        if (!DemoService.instance) {
            DemoService.instance = new DemoService();
        }
        return DemoService.instance;
    }

    /**
     * Check if the app is in demo mode
     */
    public isDemoMode(): boolean {
        // Check URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const companyId = urlParams.get('company_id');

        if (companyId === DemoService.DEMO_COMPANY_ID) {
            return true;
        }

        // Check cookie
        const demoCookie = read_cookie(DemoService.DEMO_COOKIE_NAME);
        return demoCookie === 'true';
    }

    /**
     * Enable demo mode
     */
    public enableDemoMode(): void {
        bake_cookie(DemoService.DEMO_COOKIE_NAME, 'true');
        bake_cookie('zooza-active-company', DemoService.DEMO_COMPANY_ID);
    }

    /**
     * Disable demo mode
     */
    public disableDemoMode(): void {
        bake_cookie(DemoService.DEMO_COOKIE_NAME, 'false');
    }

    /**
     * Get demo company ID
     */
    public getDemoCompanyId(): string {
        return DemoService.DEMO_COMPANY_ID;
    }
}